// The public event photo albums (made nightly by backend/photo_sync.py), for
// the photos page, the calendar and the results hub. Fetched once per page
// load and shared by every component that asks.

import { useEffect, useState } from 'react';

const EMPTY = { everything: null, events: [], collections: [] };
let request = null;

function load() {
  if (!request) {
    request = fetch('/api/site/photo-albums')
      .then(res => (res.ok ? res.json() : EMPTY))
      .catch(() => EMPTY);
  }
  return request;
}

// The album for an event, by its date (YYYY-MM-DD) and hill. The date is
// enough when the event had that day to itself; pass `sharedDay` when the
// caller's list has another event that day (e.g. Hartland Quay and Margam
// Deer, 9 October 2005), and then the hill must match too, allowing for
// spellings like "Curborough" vs "Curborough X" or "Loton" vs "Loton Park".
// For an undated row (old archived results, e.g. "Chateau Impney 13/14th
// July"), pass its year: the album that year whose hill starts the name.
export function findAlbum(events, date, hill, year, sharedDay = false) {
  if (!date) {
    const h = (hill || '').toLowerCase();
    const named = events.filter(e => e.url && year && e.year === Number(year) && h.startsWith(e.hill.toLowerCase()));
    return named.length === 1 ? named[0] : null;
  }
  const sameDay = events.filter(e => e.date === date && e.url);
  if (!sharedDay && sameDay.length <= 1) return sameDay[0] || null;
  const h = (hill || '').toLowerCase();
  const exact = sameDay.find(e => e.hill.toLowerCase() === h || e.venue.toLowerCase() === h);
  if (exact) return exact;
  const close = sameDay.filter(e => {
    const eh = e.hill.toLowerCase();
    return h && (eh.startsWith(h) || h.startsWith(eh));
  });
  return close.length === 1 ? close[0] : null;
}

export default function usePhotoAlbums() {
  const [albums, setAlbums] = useState(EMPTY);
  useEffect(() => {
    let cancelled = false;
    load().then(d => { if (!cancelled) setAlbums(d); });
    return () => { cancelled = true; };
  }, []);
  return albums;
}
